import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import DownloadLabel from '../../components/common/DownloadLabel/Download';
import ExportLabel from '../../components/common/ExportLabel/Export';
import InputBoxLarge from '../../components/common/InputBox/InputBoxLarge';  
import SelectBoxLarge from '../../components/common/SelectBox/SelectBoxLarge';
import './AddRecipient.css';
import CloseButton from '../../components/common/CloseButton/CloseButton';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import LargeDetailBox from '../../components/common/DetailBox/LargeDetailBox';
import { baseurl } from '../../api';
import authenticatedAxios from '../../authenticatedAxios';
import { showAlert } from '../../components/common/ExportLabel/Exporterror';

const AddRecipient = () => {
  const [formValues, setFormValues] = useState({
    name:'',
    recipients:[]
  });

  const countryOptions = [
    { label: 'Companies', value: 'Companies' },
    { label: 'User Accounts', value: 'User Accounts' },
  ];

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState('Companies');
  const [activeButton, setActiveButton] = useState('Companies');
  const [fetchedData, setFetchedData] = useState([]); 
  const [isLoading, setIsLoading] = useState(false); 
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchPlaceholder, setSearchPlaceholder] = useState('Search Company');

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  // useEffect(() => {
  //   if (selectedOption === 'Companies') {
  //     fetchOrg();
  //   } else if (selectedOption === 'User Accounts') {
  //     fetchUser();
  //   }
  // }, [selectedOption]); 

  useEffect(() => {
    if (selectedOption === 'Companies') {
      fetchOrg(searchTerm);
      // Update placeholder when selectedOption changes
      setSearchPlaceholder('Search Company');
    } else if (selectedOption === 'User Accounts') {
      fetchUser(searchTerm);
      // Update placeholder when selectedOption changes
      setSearchPlaceholder('Search User');
    }
  }, [selectedOption, searchTerm]);

   const handleInputChange = (field, value) => {
    setFormValues(prev => ({
      ...prev,
      [field]: value,
    }));
  };
  
  const handleSelectionchange = (e) => {
    const option = e.target.value;
    setSelectedOption(option); 
  };

  const togglePopup = () => {
    setIsPopupVisible(true);
  };
 

  const handleButtonClick = (buttonType) => {
    setActiveButton(buttonType);
  };
  const closePopup = () => {
    setIsPopupVisible(false);
  };

  const fetchOrg = async () => {
    setIsLoading(true);
    try {
      const response = await authenticatedAxios.get(`${baseurl}organization/?search=${searchTerm}`);
      setFetchedData(response.data.data || []);
    } catch (error) {
      console.error('Error fetching organizations:', error);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchUser = async () => {
    setIsLoading(true);
    try {
      const response = await authenticatedAxios.get(`${baseurl}accounts/users/organizational/active/?search=${searchTerm}`);
      setFetchedData(response.data.data || []);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setIsLoading(false);
    }
  };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     try {
//         const response = await authenticatedAxios.post(`${baseurl}notifications/recipient-groups/`, formValues);
        
//         if (response.status === 200) {
//             console.log('Data submitted successfully:', response.data);
            
//             setFormValues({ name: '', recipients: [] });
            
//             navigate('/recipient-groups');
//         } else {
//             console.error('Unexpected response:', response);
//         }
//     } catch (error) {
//         console.error('Error submitting form data:', error);
//     }
// };

const handleSubmit = async (event) => {
  event.preventDefault();

  // Manual frontend validation before sending the request
  if (!formValues.name.trim()) {
    showAlert("Group name cannot be empty.");
    return;
  }

  if (!formValues.recipients || formValues.recipients.length === 0) {
    showAlert("Please select at least one recipient.");
    return;
  }

  try {
    const response = await authenticatedAxios.post(`${baseurl}notifications/recipient-groups/`, formValues);
    
    if (response.status === 200 || response.status === 201) {
      console.log('Data submitted successfully:', response.data);

      // Reset form values
      setFormValues({ name: '', recipients: [] });

      // Redirect
      navigate('/recipient-groups');
    } else {
      console.error('Unexpected response:', response);
    }
  } catch (error) {
    console.error('Error submitting form data:', error);

    // Backend error messages (in case frontend validation misses something)
    if (error.response?.data?.message) {
      const messages = error.response.data.message;

      if (messages.name) {
        showAlert(messages.name[0]);
      } else if (messages.recipients) {
        showAlert(messages.recipients[0]);
      } else {
        showAlert("Something went wrong. Please try again.");
      }
    } else {
      showAlert("Something went wrong. Please try again.");
    }
  }
};


const addToGroup = async () => {
  if (!selectedItems || selectedItems.length === 0) {
    showAlert('Please select at least one item before proceeding.');
    return;
  }

  try {
    setSelectedCompanies([]);
    setSelectedUsers([]);
    setIsLoading(true);

    const response = await authenticatedAxios.get(`${baseurl}accounts/users/organizational/`);
    const users = response.data.data || [];

    let newSelectedCompanies = [];
    let newSelectedUsers = [];

    if (selectedOption === 'Companies') {
      selectedItems.forEach(companyId => {
        const associatedUsers = users.filter(user => user.organization?.id === companyId.id);

        if (associatedUsers.length > 0) {
          const organizationName = associatedUsers[0].organization.name;

          newSelectedCompanies.push({
            id: companyId,
            name: organizationName
          });

          associatedUsers.forEach(user => {
            const userName = user.full_name || user.email || 'Unnamed User';

            newSelectedUsers.push({
              id: user.id,
              name: userName
            });
          });
        }
      });

      setSelectedItems(prevSelectedItems => [
        ...prevSelectedItems,
        ...newSelectedUsers
      ]);
    } else if (selectedOption === 'User Accounts') {
      selectedItems.forEach(selectedItem => {
        const user = users.find(u => u.id === selectedItem.id);

        if (user && selectedItem.selected) {
          newSelectedUsers.push({
            id: user.id,
            name: user.full_name
          });

          if (user.organization) {
            newSelectedCompanies.push({
              id: user.organization.id,
              name: user.organization.name
            });
          }
        }
      });

      newSelectedCompanies = Array.from(
        new Map(newSelectedCompanies.map(company => [company.id, company])).values()
      );

      setSelectedItems(prevSelectedItems => [
        ...prevSelectedItems,
        ...newSelectedCompanies
      ]);
    }

    setSelectedCompanies(newSelectedCompanies);
    setSelectedUsers(newSelectedUsers);

    const userIds = newSelectedUsers.map(user => user.id);
    handleInputChange('recipients', userIds);
    setIsPopupVisible(false);

  } catch (error) {
    console.error('Error in addToGroup:', error);
  } finally {
    setIsLoading(false);
  }
};


const handleParentCheckboxChange = (event) => {
  const isChecked = event.target.checked;
  if (selectedOption === 'Companies') {
    setSelectedItems(isChecked ? fetchedData.map(item => ({ id: item.id, selected: true })) : []);
  } else if (selectedOption === 'User Accounts') {
    setSelectedItems(isChecked ? fetchedData.map(item => ({ id: item.id, selected: true })) : []);
  }
};

const handleChildCheckboxChange = (id) => {
  setSelectedItems((prevSelected) =>
    prevSelected.some(item => item.id === id)
      ? prevSelected.filter(item => item.id !== id)
      : [...prevSelected, { id, selected: true }]
  );
};

  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName="Notification/Recipient Groups/" nestedpageName="Add Recipients" linkTo="/recipient-groups" />   
        <div className='export-container'>
          <DownloadLabel />
          <ExportLabel />
        </div>
      </div>

      <div className='recipient-top-container add-input-box-container'>
        <h1 className='fts-18 black common-text ftw-5'>
          Recipient group 
        </h1>
        <button className="add-to-recipient-group-button popup-add-button white fts-15 ftw-5" onClick={handleSubmit}>Add Recipients Group</button>
        <InputBoxLarge
          label="Group Name"
          type="text"
          name="name"
          defaultValue={formValues.name}
          onChange={(e) => handleInputChange('name', e.target.value)}
        />
        {/* <LargeDetailBox label="Created Date"  /> */}
      </div>

      <div className='recipient-top-container'>
        <div className='recipient-heading'>
          <h1 className='fts-18 black common-text ftw-5'>Recipients List</h1>
          <button 
            className='fts-15 common-text lt-gray ftw-4 add-recipient-button bg-white'
            onClick={togglePopup}
          >
            Add Recipients
          </button>
        </div>
        <div className='selected-company-and-users'>
          <div className='buttons-recipient'>
            <a className='common-text fts-15 fts-4 black'
              onClick={() => handleButtonClick('Companies')}
              style={{
                background: 'none',
                border: 'none',
                borderBottom: activeButton === 'Companies' ? '2px solid #094C80' : 'none',
              }}
            >
              Companies
            </a>
            <a
              className='common-text fts-15 fts-4 black'
              onClick={() => handleButtonClick('Users')}
              style={{
                background: 'none',
                border: 'none',
                borderBottom: activeButton === 'Users' ? '2px solid #094C80' : 'none',
              }}
            >
              User Accounts
            </a>
          </div>

          {activeButton === 'Companies' && (
            <div className='selected-companies-page selected-companies '>
              {selectedCompanies.length > 0 ? (
                selectedCompanies.map((company, index) => (
                  <div key={index}>
                    <span className='common-text fts-15 ftw-4 black'>{company.name}</span>
                  </div>
                ))
              ) : (
                <div>
                  <span className='common-text fts-15 ftw-4 black'></span>
                </div>
              )}
            </div>
          )}

          {activeButton === 'Users' && (
            <div className='selected-users-page selected-companies'>
              {selectedUsers.length > 0 ? (
                selectedUsers.map((user, index) => (
                  <div key={index}>
                    <span className='common-text fts-15 ftw-4 black'>
                      {user.name}
                    </span>
                  </div>
                ))
              ) : (
                <div>
                  <span className='common-text fts-15 ftw-4 black'></span>
                </div>
              )}
            </div>
          )}

        </div>

      </div>


      {isPopupVisible && (
        <div className="popup-overlay">
          <div className="popup add-popup popup1">
            <CloseButton onClick={closePopup} />
            <div className="popup-name-button">
              <h2 className="popup-name">Select Recipients</h2>
              <button className="popup-add-button white fts-15" onClick={addToGroup} >Add To Group</button>
            </div>
            <div className="popup-body">
              <div className="recipient-list add-input-box-container">
                <SelectBoxLarge
                  options={countryOptions}
                  defaultValue={selectedOption}
                  onChange={handleSelectionchange} 
                />

                <div className="search-recipient-container">
                  <input
                    className="search-recipient"
                    label="Search Companies or User Accounts"
                    placeholder={searchPlaceholder}
                    onChange={(e) => handleSearchChange(e.target.value)}
                  />
                  <div className="">
                    <svg className='search-recipient-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    </svg>
                  </div>
                </div>
                {selectedOption === 'Companies' && (
                  <div className="table-container-recipient" id="company-option">
                      <table className="compnies-popup common-table">
                          <thead className="recipient-common-table-head">
                              <tr className="recipient-common-table-thead-tr">
                                  <th className="company-name-th left-radius">Company Name</th>
                                  <th className='right-radius'>
                                      <input
                                        className="table-selectbox table-parent-selectbox"
                                        type="checkbox"
                                        name="selectAll"
                                        onChange={handleParentCheckboxChange}
                                        checked={fetchedData.length > 0 && selectedItems.length === fetchedData.length}
                                      />
                                  </th>
                              </tr>
                          </thead>
                          <tbody className="recipient-common-table-tbody">
                              {fetchedData.length > 0 ? (
                                  fetchedData.map((company) => (
                                      <tr className="recipient-common-table-body-tr" key={company.id}>
                                          <td className="company-name-td">{company.name}</td>
                                          <td>

                                              <input
                                                className="table-selectbox table-child-selectbox"
                                                type="checkbox"
                                                name="language"
                                                checked={selectedItems.some(item => item.id === company.id)}
                                                onChange={() => handleChildCheckboxChange(company.id)}
                                              />

                                          </td>
                                      </tr>
                                  ))
                              ) : (
                                  <tr>
                                    
                                  </tr>
                              )}
                          </tbody>
                      </table>
                  </div>
              )}


              {selectedOption === 'User Accounts' && (
                  <div className="table-container-recipient" id="user-accounts-option">
                      <table className="users-popup common-table">
                          <thead className="recipient-common-table-head">
                              <tr className="recipient-common-table-thead-tr">
                                  <th className="user-name-th left-radius">User NAME</th>
                                  <th className="user-name-th">Company NAME</th>
                                  <th className='right-radius'>
                                      <input
                                        className="table-selectbox table-parent-selectbox"
                                        type="checkbox"
                                        name="selectAll"
                                        onChange={handleParentCheckboxChange}
                                        checked={fetchedData.length > 0 && selectedItems.length === fetchedData.length}
                                      />
    
                                  </th>
                              </tr>
                          </thead>
                          <tbody className="recipient-common-table-tbody">
                              {fetchedData.length > 0 ? (
                                  fetchedData.map((user) => (
                                      <tr className="recipient-common-table-body-tr" key={user.id}>
                                          <td className="user-name-td">{user.full_name}</td>
                                          <td className="user-name-td">{user.organization?.name || 'Unknown Company'}</td> 
                                          <td>
                                              <input
                                                className="table-selectbox table-child-selectbox"
                                                type="checkbox"
                                                name="language"
                                                checked={selectedItems.some(item => item.id === user.id)}
                                                onChange={() => handleChildCheckboxChange(user.id)}
                                              />                                              
                                          </td>
                                      </tr>
                                  ))
                              ) : (
                                  <tr>
                                      
                                  </tr>
                              )}
                          </tbody>
                      </table>
                  </div>
              )}

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddRecipient;



